export default "__VITE_ASSET___JL_AUjX__"